import React, { useEffect, useState } from 'react'
import { FaSpinner } from 'react-icons/fa';
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux';

import { fetchPopDashboard, saveDataPopDashboard } from '../../../Redux/Actions/TaskerDashboardAction';
const PopDashboardModel = (props) => {
    const dispatch = useDispatch()
    const [popData, setPopData] = useState([])
    const [loader, setLoader] = useState({
        fetch: false,
        save: false,

    })
    const fetchData = () => {
        setLoader({
            ...loader,
            fetch: true
        })
        dispatch(fetchPopDashboard("user-popup-notification", setPopData, setLoader, loader))
    }
    useEffect(() => {
        fetchData()

        if (popData.status === "1") {
            props.handleShow2()
        }
    }, [popData.status])
    const handleSave = (type) => {
        setLoader({ ...loader, save: true })
        let formData = {
            id: type
        }
        dispatch(saveDataPopDashboard("mark-seen", formData, setLoader, loader, props.handleClose))
    }

    return (
        <>
            <Modal className="theme-modal forgotpass-moda creator_new_task link_submit_modal" show={props.show} onHide={props.handleClose} backdrop="static" centered>
                <Modal.Header closeButton style={{ borderBottom: "0" }}>
                </Modal.Header>
                <Modal.Body className='pt-0'>




                    <div className="modal-card mt-4 ">
                        <div className='account-block mb-0 px-1 py-1'>


                            {popData.image && (
                                <img
                                    src={popData.image}
                                    alt=""
                                    className='w-100 rounded-2'
                                    style={{ height: "100%", objectFit: "contain", aspectRatio: "4/3" }}
                                />
                            )}

                            <div className='submission_wrap submission_bg mt-3 mb-3 pt-3'>
                                {popData.heading && (
                                    <h5 className='mb-2'>{popData.heading}</h5>
                                )}

                                {popData.subheading && (
                                    <h6>{popData.subheading}</h6>
                                )}

                                {popData.description && (
                                    <div style={{ height: "8rem", overflowY: "auto" }}>
                                        <p dangerouslySetInnerHTML={{ __html: popData.description }} />
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="link_btn text-end my-2">
                            <button className='theme-btn saveBtn ms-auto me-2 d-flex' type="button" onClick={() => handleSave(popData.id)} style={{ padding: "8px 24px" }}>Seen {loader.save ? <FaSpinner className="spin ms-1" /> : null}</button>
                        </div>
                    </div>

                </Modal.Body>
            </Modal >
        </>
    )
}

export default PopDashboardModel